import React, { Component } from "react";
import { Spin, message } from 'antd';
import { lineitemStates } from '../../../lib/util'
import Header from "./Header";
import Footer from "./Footer";
import Targeting from "./Targeting";
import LineitemList from "../../../components/LineitemList";
import Sidesheet from "../../../components/Sidesheet";

class Project extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sidesheetClass: ''
    }
    this.saveSurveyQa = this.saveSurveyQa.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.openSidesheet = this.openSidesheet.bind(this);
    this.closeSidesheet = this.closeSidesheet.bind(this);
  }

  componentDidMount() {
    const { projectUUID, lineItemUUID } = this.props.match.params;
    this.props.actions.loadProject(projectUUID, lineItemUUID);
    this.props.actions.loadUsers();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { viewState, project, errMessage } = nextProps;
    const { lineItemUUID } = nextProps.match.params;
    
    if (viewState === "PROJECT_DID_LOAD") {
      this.props.actions.loadSurveyQaInfo(lineItemUUID);
      this.props.actions.loadSurveyQuestionnaire();
      this.props.actions.loadLineitemsByProjectId({extProjectId: project.getId(), state: lineitemStates})
      this.props.actions.loadHistory(lineItemUUID)
    }
    if (viewState === "SURVEY_QA_SAVED") {
      message.success("Changes saved!");
      this.props.history.push('/dashboard/lineitems');
      // this.props.actions.loadHistory(lineItemUUID)
    }
    if(viewState === "SERVER_ERROR") message.error(errMessage)
  }

  openSidesheet () {
    this.setState({ sidesheetClass: 'axiom-sidesheet-open' })
  }

  closeSidesheet () {
    this.setState({ sidesheetClass: '' })
  }

  handleUserChange(value, lineItemUUID, projectUUID) {
    const type = value === 'unassign' ? "unassign" : "assign";
    const assignVal = value === 'unassign' || value === 'assignme' ? '' : value
    this.props.actions.updateAssignedUser(
      lineItemUUID,
      { assignedTo: assignVal },
      type,
      { qaState: "PRE_APPROVE,PRE_APPROVED,POST_APPROVED" },
      projectUUID
    );
    const { project } = this.props;
    const lineItem = project.getLineItem();
    lineItem[0].setAssignedUser(value);
  }

  saveSurveyQa(type, request) {
    const { lineItemUUID } = this.props.match.params;
    this.props.actions.saveSurveyQa(lineItemUUID, type, request);
  }

  render() {
    const { isFetching, project, attributes, viewState, lineitemsByProjectId, lineitems, questionnaire, lineItemHistory } = this.props;
    const lineItem = project.getLineItem();
    const filteredLineitems = lineitemsByProjectId.filter(le => le.extLineItemId !== lineItem[0].getId())

    if (isFetching) {
      return <Spin className="spin-container" />
    } else {
      return (
        <>
          {lineItem && lineItem.length &&
            <div className='wrapper'>
              <Header 
                users={lineitems.users}
                lineitem={lineItem[0]} 
                viewState={viewState}
                handleUserChange={this.handleUserChange}
                openSidesheet={this.openSidesheet}
              />
              <LineitemList
                project={project}
                lineitems={filteredLineitems}
              />
              <Targeting {...this.props} />
              <Footer
                history={this.props.history}
                lineItemHistory={lineItemHistory}
                attributes={attributes}
                project={project}
                saveSurveyQa={this.saveSurveyQa}
                viewState={viewState}
                questionnaire={questionnaire}
              />
            </div>
          }
          {lineItemHistory && <Sidesheet 
            sidesheetClass={this.state.sidesheetClass}
            closeSidesheet={this.closeSidesheet}
            history={lineItemHistory}
          />}
        </>
      );
    }
  }
}

export default Project
